import styled from 'styled-components';

export const InfoBox = styled.div`
  border: 1px solid #ddd;
  padding: 12px 10px;
  width: 100%;
  color: black;
  background: ${p => p.theme.gray.lightest};
`;
